module.exports = __webpack_public_path__ + "img/scratch.2cd536a5.png";